var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-complaint-handling-photos"},[_c('print-photos',{attrs:{"id":_vm.id,"api-name":"complaintHandlingReport"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }